var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('project-information', {
    attrs: {
      "project": _vm.project,
      "graph": _vm.graph
    }
  }), _vm.graph.length > 0 ? [_c('div', {
    class: [_vm.$style.graph, (_ref = {}, _ref[_vm.$style.visible] = _vm.isVisibleGraph, _ref)]
  }, [_c('transaction-chart', {
    attrs: {
      "data": _vm.graph
    }
  })], 1)] : _vm._e(), _vm.isPersonalProject ? [_c('div', {
    class: _vm.$style.controls
  }, [_c('project-control', {
    attrs: {
      "project": _vm.project
    }
  })], 1), _c('div', {
    class: _vm.$style.slides
  }, [_c('information-sliding')], 1)] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }